'use client';


import { Suspense, useEffect } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import Chatbot from '@/components/common/Chatbot';
import TrackShipmentInteractive from './components/TrackShipmentInteractive';
import { analytics } from '@/lib/analytics';

export default function TrackShipmentPage() {
  useEffect(() => {
    analytics.trackPageView('/track-shipment');
  }, []);

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background pt-24">
        {/* Page Header */}
        <div className="bg-gradient-to-br from-primary/5 to-secondary/5 py-12 border-b border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
              Track Your Shipment
            </h1>
            <p className="text-lg text-muted-foreground">
              Real-time tracking with country-specific codes for complete transparency
            </p>
          </div>
        </div>

        <Suspense fallback={
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="bg-muted rounded-xl p-12 text-center">
              <p className="text-muted-foreground">Loading tracking form...</p>
            </div>
          </div>
        }>
          <TrackShipmentInteractive />
        </Suspense>
      </main>
      <Footer />
      <Chatbot />
    </>
  );
}